import { render, staticRenderFns } from "./capacitacion-coppast1.2.1.vue?vue&type=template&id=2bbfa2b6&"
import script from "./capacitacion-coppast1.2.1.vue?vue&type=script&lang=js&"
export * from "./capacitacion-coppast1.2.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports